<div class="flex-1 d-flex fd-col ai-stretch">
  <span class="header">{{ option.filterMethodConfig?.title || 'Years Drop Down' }}</span>

  <div *ngIf="formGroup" class="d-flex fd-row gap-8" style="flex: 0 1" [formGroup]="formGroup">
    <div class="basis-50">
      <!-- Greater Than -->
      <mat-form-field class="form-field" appearance="outline">
        <mat-label>Minimum</mat-label>
        <mat-select formControlName="greaterThan">
          <mat-option>No Minimum</mat-option>
          <mat-option *ngFor="let year of yearOptions" [value]="year">{{ year }}</mat-option>
        </mat-select>

        <suvo-bi-clear-control-button
          matSuffix
          [clearFormGroup]="formGroup"
          clearFormControlName="greaterThan"
        >
        </suvo-bi-clear-control-button>
      </mat-form-field>
    </div>
    <div class="basis-50">
      <!-- Less Than -->
      <mat-form-field class="form-field" appearance="outline">
        <mat-label>Maximum</mat-label>
        <mat-select formControlName="lessThan">
          <mat-option>No Maximum</mat-option>
          <mat-option *ngFor="let year of yearOptions" [value]="year">{{ year }}</mat-option>
        </mat-select>

        <suvo-bi-clear-control-button
          matSuffix
          [clearFormGroup]="formGroup"
          clearFormControlName="lessThan"
        >
        </suvo-bi-clear-control-button>
      </mat-form-field>
    </div>
  </div>
</div>
